import { css, styled } from 'styled-components';

type BadgeSize = 'lg' | 'md' | 'sm' | 'xs';

type Variant = 'default' | 'gray' | 'white' | 'whiteBorder';

const getDimensions = (size: BadgeSize) => {
  switch (size) {
    case 'lg':
      return css`
        padding: 4px 8px;
        font-size: 12px;
        line-height: 16px;
      `;
    case 'sm':
      return css`
        padding: 3.5px 4px;
        font-size: 10px;
        line-height: 12px;
      `;
    case 'xs':
      return css`
        padding: 2px 5px;
        font-size: 10px;
        line-height: 12px;
        letter-spacing: 0.5px;
      `;
    case 'md':
    default:
      return css`
        padding: 4px 8px;
        font-size: 12px;
        line-height: 16px;
      `;
  }
};

const getColor = ({ variant }: { readonly variant: Variant }) => {
  switch (variant) {
    case 'gray':
      return css`
        background: ${({ theme }) => theme.colorsV2.gray70};
        color: ${({ theme }) => theme.colorsV2.gray20};
        border: 1px solid ${({ theme }) => theme.colorsV2.gray60};
      `;
    case 'white':
      return css`
        background: ${({ theme }) => theme.colorsV2.white};
        color: ${({ theme }) => theme.colorsV2.gray80};
        border: 1px solid ${({ theme }) => theme.colorsV2.gray30};
      `;

    case 'whiteBorder':
      return css`
        background: ${({ theme }) => theme.gradients.primaryOpaque};
        color: ${({ theme }) => theme.colorsV2.yellow80};
        border: 2px solid ${({ theme }) => theme.colorsV2.white};
      `;

    case 'default':
    default:
      return css`
        background: ${({ theme }) => theme.gradients.primaryOpaque};
        color: ${({ theme }) => theme.colorsV2.yellow80};
      `;
  }
};

const Badge = styled.div<{ size: BadgeSize; variant: Variant }>`
  ${({ size, variant }) => css`
    ${getDimensions(size)}
    display: grid;
    place-items: center;
    width: fit-content;

    border-radius: 4px;

    ${getColor({
      variant,
    })}

    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.6px;
  `}
`;

export const ProBadge = ({
  className,
  size = 'md',
  variant = 'default',
}: {
  readonly className?: string;
  readonly size?: BadgeSize;
  readonly variant?: Variant;
}) => {
  return (
    <Badge
      className={className}
      size={size}
      variant={variant}
    >
      pro
    </Badge>
  );
};
